import * as Yup from 'yup';

export function newLocationSchema(shouldValidate = false) {
  return Yup.object().shape({
    school: Yup.object().shape({
      address: shouldValidate
        ? Yup.object()
            .nullable()
            .shape({
              address: Yup.string(),
              calendar: Yup.string(),
              calendarName: Yup.string(),
              dropoffProcedureInstructions: Yup.string(),
              group: Yup.string(),
              id: Yup.string(),
              label: Yup.string(),
              latLng: Yup.string(),
              locationType: Yup.string(),
              name: Yup.string().trim().required('Required Field'),
              passengerCount: Yup.string(),
              pickupProcedureInstructions: Yup.string(),
              placeId: Yup.string(),
            })
            .required('Required Field')
        : Yup.object().nullable(),
      streetAddressTwo: Yup.string().trim(),
    }),
  });
}
